import { sendGTMEvent } from '@next/third-parties/google'
import { getMe } from '@/data/api/user'
import { getUserId, setUserId } from '@/data/cache/user'
// import { getAmplitude } from './amplitude'
// import { trackMxEvent } from './mixpanel'

export const GA_ID = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID || ''
export const GTM_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID || 'GTM-PFN7TPC'
interface Args {
  event: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
}
interface EventParams extends Args {
  user_id?: string
}

export const sendEvent = async ({ event, ...params }: Args) => {
  // trackMxEvent(event, params)
  // const amplitude = getAmplitude()
  // amplitude?.track(event, params)
  const eventParams: EventParams = {
    event,
    ...params,
  }
  const userId = getUserId()
  if (userId) {
    eventParams.user_id = userId
  }
  else {
    const me = await getMe()
    if (me && !('error' in me)) {
      setUserId(me.user.id)
      eventParams.user_id = getUserId()
    }
  }

  sendGTMEvent(eventParams)
}

// 広告用コンバージョン - 登録ボタン
export function cvRegisterButton() {
  sendEvent({ event: 'cv_register_button' })
}

// 広告用コンバージョン - 新規登録
export function cvSignup() {
  sendEvent({ event: 'cv_signup' })
}

// 広告用コンバージョン - お問い合わせ
export function cvContact() {
  sendEvent({ event: 'cv_contact' })
}

// 広告用コンバージョン - 無料サポートお問い合わせ
export function cvSupportContact() {
  sendEvent({ event: 'cv_support_contact' })
}

// 広告用コンバージョン - ワークスプレイ
export function cvProWorksPlay() {
  sendEvent({ event: 'cv_pro_works_play' })
}

// 広告用コンバージョン - プロ申請ボタンクリック
export function cvProRegister() {
  sendEvent({ event: 'cv_pro_register' })
}
